'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import TextLink from '@/components/Link/TextLink';

import {
  TABLET_BREAKPOINT,
  MOBILE_BREAKPOINT,
} from '../AboutJosh.constants';
import BaseChild from './BaseChild';

function CardDesk(delegated: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Wrapper {...delegated}>
      {/* eslint-disable-next-line */}
      <img
        className="inset"
        alt="A desk with a computer monitor, but no keyboard or mouse. Instead, a microphone sits in front of the monitor"
        src="/images/no-keyboard-cropped.jpg"
      />
      <p>
        I spent ~6 months unable to use a keyboard or mouse, and
        learned to{' '}
        <TextLink href="/blog/hands-free-coding">
          code by voice
        </TextLink>
        .
      </p>
    </Wrapper>
  );
}

const Wrapper = styled(BaseChild)`
  /* On tablet, CardCat is right below and the ears encroach */
  @media (max-width: ${TABLET_BREAKPOINT}rem) {
    padding-bottom: 24px;
  }
  /* On mobile, CardCat wanders elsewhere */
  @media (max-width: ${MOBILE_BREAKPOINT}rem) {
    padding-bottom: 16px;
  }
`;

export default CardDesk;
